import {Injectable} from '@angular/core';

import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BaseService} from '../../core/service/base.service';
import {WorkdayLog} from './resource/workday-log';
import {Observable} from 'rxjs';
import {FileResource} from '../../model/file';
import {HeaderConstants} from '../../core/utils/headers.constants';

@Injectable()
export class WorkdayLogService extends BaseService<WorkdayLog> {

  serviceUrl(): string {
    return `/api/t/{tenant}/workday-logs`;
  }

  constructor(protected http: HttpClient) {
    super(http);
  }


  getAttachments(id: number): Observable<FileResource[]> {
    return this.http
      .get<FileResource[]>(`${this.serviceUrl()}/${id}/attachment`);
  }

  deleteAttachment(id: number, attachmentId: number): Observable<any> {
    return this.http
      .delete(`${this.serviceUrl()}/${id}/attachment/${attachmentId}`);
  }

  uploadAttachments(formData: FormData, workdayLogId : number): Observable<any> {
    return this.http.post<any>(`${this.serviceUrl()}/${workdayLogId}/attachment`, formData, {
      headers: new HttpHeaders().set(HeaderConstants.IGNORE_CONTENT_TYPE, 'true')
    });
  }

  downloadAttachment(id: number, attachmentId: number): Observable<any> {
    return this.http.get(`${this.serviceUrl()}/${id}/attachment/${attachmentId}`, {responseType: 'blob'});
  }

  import(formData: FormData): Observable<any> {
    return this.http.post<any>(`${this.serviceUrl()}/import`, formData, {
      headers: new HttpHeaders().set(HeaderConstants.IGNORE_CONTENT_TYPE, 'true')
    });
  }

  generateMissing(payload: WorkdayLogGenerationResource): Observable<void> {
    return this.http.post<void>(`${this.serviceUrl()}/generate-missing`, payload);
  }
}

export interface WorkdayLogGenerationResource {
  startDate: string;
  endDate: string;
  employeeIds: number[];
}
